import { useTreeStateContext } from "../../contexts/TreeContext";
import generateObjectId from "../../utils/generateObjectId";
import editorAction from '../../actions/editorAction';
import {getWidth, getHeight, getTransformByBlocks} from "./categoryModel";
function useCategories() {

    const { createCategory: createCategoryAction, updateCategory: updateCategoryAction, deleteCategory: deleteCategoryAction, addBlocksInCategory: addBlocksInCategoryAction, ungroupBlockFromCategory: ungroupBlockFromCategoryAction } = editorAction();

    const { categories } = useTreeStateContext();

    const getCategoryById = (id)=>{
        return categories.find(c=>c.category.id === id)
    }
    const getCategoryByObjectId = (id)=>{
        return categories.find(c=>c.object_id === id)
    }
    const createCategory = (blocks_id) => {
        let dataToSend = {
            color: "#7AAFF9",
            name: "New Title",
            object_id: generateObjectId(),
            blocks_object_id: blocks_id//.id)
        }
        createCategoryAction(dataToSend)
    }

    const updateCategory = async (id, data) => {
        data.name = data.name.trim()
        data.id = id;
        updateCategoryAction(id, data)
    }

    const lockCategory = async (id, locked) => {
        let data = { id: id, locked: locked }
        updateCategoryAction(id, data)
    }

    const deleteCategory = async (id) => {
        let data = { id: id }
        deleteCategoryAction(id, data);
    }

    const addBlocksInCategory = async (id, listBlockSelected) => {
        let listBlocksObjectId = listBlockSelected.map(block => block.object_id);
        let data = { id: id, blocks_object_id: listBlocksObjectId }

        addBlocksInCategoryAction(id, data);
    }

    const ungroupBlockFromCategory = async (block) => {
        let data = { block_object_id: block.object_id}
        await ungroupBlockFromCategoryAction(block, data)
    }

    const moveCategories = (categories_to_move)=>{
        for (let category of categories_to_move) {
            moveCategory(category.category_id, category.blocks);
        }
    }

    const moveCategory = (categoryId,blocksUpdated) => {
        
        let infoCategory = getCategoryById(categoryId);
        if (infoCategory == null) return;
        let categoryElement = document.getElementById(infoCategory.object_id)

        let blocks = infoCategory.category.categories_blocks.map(block => block.blocks)

        blocks = blocks.map( block =>{
            let blockUpdated = blocksUpdated.find(b => b.id === block.id);
            return blockUpdated ? { ...block, x: blockUpdated._x, y: blockUpdated._y } : block;
        })
        let transform = getTransformByBlocks(blocks);
        categoryElement.style.transform = "translate3d("+ transform.x +"px,"+ transform.y +"px,"+ 0 + "px)";

        categoryElement.style.width = getWidth(blocks) + "px"
        categoryElement.style.height = getHeight(blocks) + "px"
    }

    return { createCategory, updateCategory, lockCategory, deleteCategory, addBlocksInCategory, ungroupBlockFromCategory, moveCategories,getCategoryById,getCategoryByObjectId };
}

export default useCategories;